// Used by: Home, PortalHome
import getClassName from "../../utilities/getClassName";

const TripTypeTabs = ({ tripType, onTripTypeChange, className = "" }) => {
    return (
        <div className={getClassName(["trip-type-tabs", className])}>
            <button
                type="button"
                className={getClassName(["trip-type-tab", tripType === "oneway" ? "trip-type-tab--active" : ""])}
                onClick={() => onTripTypeChange("oneway")}
            >
                ONE WAY
            </button>
            <button
                type="button"
                className={getClassName(["trip-type-tab", tripType === "returns" ? "trip-type-tab--active" : ""])}
                onClick={() => onTripTypeChange("returns")}
            >
                RETURN TRIP
            </button>
            <button
                type="button"
                className={getClassName(["trip-type-tab", tripType === "multilegs" ? "trip-type-tab--active" : ""])}
                onClick={() => onTripTypeChange("multilegs")}
            >
                MULTI-LEG
            </button>
        </div>
    );
};

export default TripTypeTabs;
